import React from 'react';
import PropTypes from 'prop-types';

import { Heading, Text } from 'components/common/Elements/Elements';

import classes from './Cart.module.scss';

const Cart = ({ data: { title = '', contentText = '' } = {} }) => {
  return (
    <section className={classes.box}>
      <Heading>{title}</Heading>
      <Text weight="b" className={classes.content}>
        {contentText}
      </Text>
    </section>
  );
};

Cart.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    contentText: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

export default Cart;
